import { createSlice } from "@reduxjs/toolkit";
import { grossFeeRequest } from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  grossFeeStatus: null, // "loading" | "success" | "failed"
  error: null,
};

export const grossFeeSlice = createSlice({
  name: "grossfee",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(grossFeeRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(grossFeeRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.grossFeeStatus = action.payload;
        message.success(action.payload.message);
      })
      .addCase(grossFeeRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.grossFeeStatus = action.payload;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default grossFeeSlice.reducer;
